<template>
  <OmtStickedModal v-if="isOpen" @close="$emit('close')">
    <CBox>
      <OmtRow mt="16px">
        <OmtIcons name="circle-xmark" size="3x" mb="32px" color="var(--colors-light-support-error)" />
      </OmtRow>
      <OmtRow mb="32px">
        <OmtTypography as="h1-large">
          Acesso bloqueado <br />
          temporariamente
        </OmtTypography>
      </OmtRow>

      <CBox mt="32px" bg="#f6f6f9"
border-radius="8px">
        <div class="warning">
          <CFlex px="16px" pt="24px" pb="16px" align-items="center">
            <OmtIcons name="mobile" mr="16px"
size="1x" />
            <OmtTypography as="h2-bold">
              <omt-bold>Tentativas excedidas</omt-bold>
            </OmtTypography>
          </CFlex>
          <CFlex px="16px" pb="24px">
            <OmtTypography as="p1">
              {{ message }}
            </OmtTypography>
          </CFlex>
        </div>
      </CBox>
    </CBox>
    <OmtRow mt="24px">
      <OmtButton w="100%" @click="$emit('close')"> Concluir </OmtButton>
    </OmtRow>
  </OmtStickedModal>
</template>

<script>
export default {
  name: "LoginRefusedModal",
  props: {
    isOpen: {
      Type: Boolean
    },
    message: {
      type: String,
      default:
        "Você excedeu o número de tentativas de login. Por segurança, bloqueamos o acesso temporariamente. Tente novamente em alguns minutos."
    }
  }
};
</script>
